import { render, staticRenderFns } from "./OmzP_List.vue?vue&type=template&id=4d789067"
import script from "./OmzP_List.vue?vue&type=script&lang=js"
export * from "./OmzP_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports